<div [dir]="direction" style="display: flex">
  <div class="env" [style]="{ color: envParam.color, backgroundColor: envParam.backgroundColor }" *ngIf="envParam.show">
    {{ envParam.name }}
  </div>
  <app-release-note-button *ngIf="!hideMenu"></app-release-note-button>
  <app-loader></app-loader>
  <app-menu *ngIf="!hideMenu"></app-menu>
  <div style="display: flex; flex-direction: row">
    <app-header *ngIf="!hideMenu" class="header-app"></app-header>
    <div class="main-content {{ hideMenu ? 'main-content-no-menu' : '' }}" cdkScrollable>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
